import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AuthenticationStore } from '../permission/services/authentication.store';
import { SpinnerService } from '../shared/spinner.service';

@Injectable()
export class AppAuthHttpService {

  constructor(
    private http: AuthHttp,
    private authenticationStore: AuthenticationStore,
    private spinnerService: SpinnerService,
  ) { }

  get(url: string, options?: RequestOptionsArgs, isSpinner = true): Observable<Response> {
    if (isSpinner) {this.spinnerService.start(); }
    return this.http.get(url, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        if (isSpinner) {this.spinnerService.finish(); }
      });
  }

  post(url: string, body: any, options?: RequestOptionsArgs, isSpinner = true): Observable<Response> {
    if (isSpinner) {this.spinnerService.start(); }
    return this.http.post(url, body, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
         if (isSpinner) {this.spinnerService.finish(); }
      });
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.put(url, body, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    this.spinnerService.start();
    return this.http.delete(url, options)
      .map((response: Response) => {
        this.refreshTokenFromResponse(response);
        return response;
      })
      .finally(() => {
        this.spinnerService.finish();
      });
  }

  private refreshTokenFromResponse(response: Response) {
    const token = response.headers.get('Authorization');
    const exp = response.headers.get('X-Token-Expiration');
    this.authenticationStore.refreshToken(token, exp);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/http/app.auth.http.service.ts